import retryPromise from '@bwoty-web/retry-promise';
import { jsonFetch } from '../utils/fetch';
import { createInitialQuery, createGetTripsQuery } from './queries';

const fetch = retryPromise(jsonFetch);

function intOrNull(v) {
  const n = parseInt(Number(v), 10);

  if (!Number.isNaN(n)) {
    return n;
  }

  return null;
}

function arrayOrNull(v) {
  // eslint-disable-next-line no-nested-ternary
  return v ? (Array.isArray(v) ? v : [v]) : null;
}

const queryToParams = (query = {}) => {
  return {
    orderBy: query.orderBy || 'DATE',
    durationFrom: intOrNull(query.durationFrom),
    durationTo: intOrNull(query.durationTo),
    dateFrom: query.dateFrom || null,
    dateTo: query.dateTo || null,
    priceTo: intOrNull(query.priceTo),
    departureCode: arrayOrNull(query.departure),
    destinationCode: arrayOrNull(query.destinationCode),
    tripType: arrayOrNull(query.tripTypes),
    after: query.after || null,
  };
};

function mapReponse(data) {
  const tripData = data?.lmsTrips || {};
  const meta = tripData?.metadata || {};

  return {
    departures: meta?.departures || [],
    dates: meta?.availableDates || [],
    countries: meta?.countries || [],
    durations: meta?.hasDurations || {},
    price: {
      max: meta?.maxPrice || 0,
      min: meta?.minPrice || 0,
    },
    nrOfSpecified: meta?.nrOfSpecified || 0,
    nrOfFlightOnly: meta?.nrOfFlightOnly || 0,
    nrOfUnspecified: meta?.nrOfUnspecified || 0,
    totalCount: meta?.totalCount || 0,
    offers: tripData?.edges || [],
    messages: tripData?.messages || [],
    pageInfo: tripData?.pageInfo || {},
  };
}

export async function getInitial(settings, query = {}) {
  try {
    const { siteId, attributeCollection, hitsPerPage } = settings;

    let limit = hitsPerPage;
    if (query.page) {
      limit = query.page ? hitsPerPage * parseInt(query.page, 10) : hitsPerPage;
    }

    const requestBodyAndHeaders = createInitialQuery(
      siteId,
      attributeCollection,
      limit,
      queryToParams(query),
    );

    const result = await fetch(settings.origoUrl, requestBodyAndHeaders);

    const data = result?.data || {};

    return {
      texts: data?.attributeCollection?.[settings.attributeCollection] || {},
      ...mapReponse(data),
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('error in fetch', e);
  }

  return {};
}

export async function getTrips(settings, query = {}) {
  try {
    const { siteId } = settings;
    const result = await fetch(
      settings.origoUrl,
      createGetTripsQuery(siteId, queryToParams(query)),
    );

    const data = result?.data || {};

    return {
      ...mapReponse(data),
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('error in fetch', e);
  }

  return {};
}
